/**
 * The rashi check's form props, shared by the server-rendered shell
 * (RashiCheckLazy), the island's BirthDetailsForm and
 * BirthToolFormShell.parity.test.tsx, so every frame before and after the
 * island loads reads the same words. No name field: the answer is the seeker's
 * Moon sign, and a name adds nothing to it. The birth time is optional: the
 * date alone settles the sign on most days (rashi-check.ts says when it does).
 */
export const RASHI_CHECK_FORM = {
  language: "en",
  submitLabel: "Check My Rashi",
  collectName: false,
} as const;

/**
 * One box for every state of the check's slot (the /nakshatra/<slug>/ finder's
 * frame): the shell, the loading shell, the live form and the verdict each
 * fill the slot's reserved height, so no swap moves the page below. The action
 * sits at the foot of the box in every state, and the submit keeps one 48 px
 * height (the shared Button is 44 px with its loading spinner).
 */
export const RASHI_CHECK_FRAME =
  "mx-auto flex w-full max-w-md flex-1 flex-col [&>form]:flex [&>form]:flex-1 [&>form]:flex-col [&>form>:last-child]:mt-auto [&>form>:last-child]:min-h-12";

/** The real form's input ids (no heading prop, so BirthDetailsForm's "-default" ids). */
export const RASHI_CHECK_FIELD_IDS = {
  date: "birthDate-default",
  time: "birthTime-default",
  place: "birthPlace-default",
} as const;

/** free_tool_started and calculator_used placement for the sign-page check. */
export const RASHI_CHECK_PLACEMENT = "rashi_page_check";

/**
 * What a missing birth time means for THIS tool. The shared explainer speaks for
 * the whole chart (no exact Lagna, houses or dasha timing; the Moon can change
 * sign within a day); this one says what the check does instead, from the
 * engine's day windows: the date settles a sign the Moon held all day, and a
 * day it changed sign shows the time of the change and the sign on each side.
 */
export const RASHI_TIME_UNKNOWN_EXPLAINER =
  "No problem: the check uses your birth date at your birth place. If the Moon stayed in one sign all day, the date settles your rashi. If it changed sign that day, you see the time of the change and the sign on each side of it.";
